<template>
  <form class="grid p-fluid mt-3">
    <div class="field col-12 md:col-6">
      <label class="text-black-alpha-90" for="inputNameId">نام اقامتگاه:</label>
      <InputText
        v-model="form.name"
        @blur="v$.form.name.$touch"
        @input="v$.form.name.$touch"
        type="text"
        id="inputNameId"
        :class="{
          'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.name.$error,
        }"
      />
      <small v-if="v$.form.name.required.$invalid && v$.form.name.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.name.required.$message }}
      </small>
    </div>
    <div class="field col-12 md:col-6">
      <label class="text-black-alpha-90" for="CategoryId">نوع اقامتگاه:</label>
      <Dropdown v-model="form.categoryId" placeholder="انتخاب کنید" id="CategoryId" :options="categories" optionLabel="title" optionValue="id">
        <template #option="slotProps">
          <div class="flex flex-row">
            <!-- <img :alt="slotProps.option.picture" :src="'https://api.koome.net/' + slotProps.option.picture" /> -->
            <span class="mr-2">{{ slotProps.option.title }}</span>
          </div>
        </template>
      </Dropdown>
    </div>
    <div class="field col-12 md:col-6">
      <label class="text-black-alpha-90" for="stateId">استان:</label>
      <Dropdown v-model="form.provinceId" :options="states" placeholder="انتخاب کنید" optionLabel="title" optionValue="id" />
    </div>
    <div class="field col-12 md:col-6">
      <label class="text-black-alpha-90" for="cityId">شهر:</label>
      <Dropdown :disabled="!form.provinceId" v-model="form.cityId" :options="getCities(form.provinceId)" optionLabel="title" optionValue="id" placeholder="انتخاب شهر" />
    </div>
    <div class="field col-12 md:col-3 lg:col-6">
      <label class="text-black-alpha-90" for="latitudeId">موقعیت جغرافیایی(عرض):</label>
      <InputText
        v-model="form.latitude"
        @blur="v$.form.latitude.$touch"
        @input="v$.form.latitude.$touch"
        type="Number"
        dir="ltr"
        id="latitudeId"
        class="input-Numbers"
        mode="decimal"
        :max="99999999"
        :useGrouping="false"
        :class="{
          'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.form.latitude.$error,
        }"
      />
      <small v-if="v$.form.latitude.required.$invalid && v$.form.latitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.latitude.required.$message }}
      </small>
      <small v-if="v$.form.latitude.maxLength.$invalid && v$.form.latitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.latitude.maxLength.$message }}
      </small>
      <small v-if="v$.form.latitude.minLength.$invalid && v$.form.latitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.latitude.minLength.$message }}
      </small>
    </div>
    <div class="field col-12 md:col-3 lg:col-6">
      <label class="text-black-alpha-90" for="longitudeId">موقعیت جغرافیایی(طول):</label>
      <InputText
        v-model="form.longitude"
        @blur="v$.form.longitude.$touch"
        @input="v$.form.longitude.$touch"
        type="Number"
        dir="ltr"
        id="longitudeId"
        class="input-Numbers"
        mode="decimal"
        :max="99999999"
        :useGrouping="false"
        :class="{
          'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.form.longitude.$error,
        }"
      />
      <small v-if="v$.form.longitude.required.$invalid && v$.form.longitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.longitude.required.$message }}
      </small>
      <small v-if="v$.form.longitude.maxLength.$invalid && v$.form.longitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.longitude.maxLength.$message }}
      </small>
      <small v-if="v$.form.longitude.minLength.$invalid && v$.form.longitude.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.longitude.minLength.$message }}
      </small>
    </div>
    <div class="field col-12 md:col-6">
      <label class="text-black-alpha-90" for="cityId">تعداد ستاره:</label>
      <Dropdown v-model="form.star" placeholder="انتخاب کنید" :options="stars" optionLabel="title" optionValue="code" />
    </div>
    <div class="field col-12">
      <label class="text-black-alpha-90" for="addressId">آدرس دقیق:</label>
      <Textarea
        inputId="addressId"
        rows="1"
        cols="30"
        v-model="form.address"
        @blur="v$.form.address.$touch"
        @input="v$.form.address.$touch"
        :class="{
          'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.address.$error,
        }"
      ></Textarea>
      <small v-if="v$.form.address.required.$invalid && v$.form.address.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.address.required.$message }}
      </small>
    </div>
    <div class="field col-12">
      <label class="text-black-alpha-90" for="placeDescriptionId">درباره هتل:</label>
      <Textarea
        inputId="placeDescriptionId"
        rows="4"
        cols="30"
        v-model="form.description"
        @blur="v$.form.description.$touch"
        @input="v$.form.description.$touch"
        :class="{
          'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.description.$error,
        }"
      ></Textarea>
      <small v-if="v$.form.description.required.$invalid && v$.form.description.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.description.required.$message }}
      </small>
    </div>
    <div class="field col-12 flex flex-row justify-content-end mt-3">
      <span class="p-float-label md:w-2">
        <Button type="button" :disabled="disabledButtonStatus" class="mr-2 mb-2" :label="!!$route.params.place_id ? 'ویرایش' : 'ایجاد'" icon="pi pi-check" :loading="loading['create']" @click="completePlaceDetail()" />
      </span>
    </div>
  </form>
</template>

<script>
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import states from "../../../public/data/location.json";
export default {
  name: "placeDetail",
  setup: () => ({ v$: useVuelidate() }),
  emits: ["report-status"],
  props: {
    categories: {
      type: Array,
      default: [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    onlyForUpdateComponent() {
      this.form = { ...this.formData };
      return this.form;
    },
    disabledButtonStatus() {
      return !!this.form.name && !!this.form.categoryId && !!this.form.provinceId && !!this.form.cityId && !!this.form.address ? false : true;
    },
  },
  data() {
    return {
      types: [
        {
          id: "hotel",
          title: "هتل",
        },
        {
          id: "motel",
          title: "مسافرخانه",
        },
      ],
      form: {
        name: "",
        categoryId: 0,
        provinceId: "",
        cityId: "",
        address: "",
        latitude: 0,
        longitude: 0,
        star: null,
        description: null,
      },
      stars: [
        {
          title: "بدون ستاره",
          code: null,
        },
        {
          title: "1",
          code: 1,
        },
        {
          title: "2",
          code: 2,
        },
        {
          title: "3",
          code: 3,
        },
        {
          title: "4",
          code: 4,
        },
        {
          title: "5",
          code: 5,
        },
      ],
      loading: {
        create: false,
      },
      radioValue: null,
      states: states,
      value: null,
    };
  },
  watch: {
    onlyForUpdateComponent() {},
  },
  methods: {
    //******* Api methods end *******//
    async completePlaceDetail() {
      this.loading["create"] = true;
      if (!!this.$route.params.place_id) {
        const { status, data } = await this.axios({ method: "put", url: `Place/${this.$route.params.place_id}`, data: this.form });
        this.showToast(status, status === 200 ? null : data.errors);
        this.$emit("report-status", { status: status, id: data });
      } else {
        const { status, data } = await this.axios({ method: "post", url: `Place`, data: this.form });
        this.showToast(status, status === 200 ? null : data.errors);
        this.$emit("report-status", { status: status, id: data });
      }
      this.loading["create"] = false;
    },
    //******* Api methods end *******//
    getCities(id) {
      return id ? this.states.filter((state) => state.id === id)[0].cities : null;
    },
  },
  validations() {
    return {
      form: {
        name: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        address: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        description: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        latitude: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          maxLength: helpers.withMessage("تعداد کاراکتر باید 8 رقم باشد", maxLength(8)),
          minLength: helpers.withMessage("تعداد کاراکتر باید 8 رقم باشد", minLength(8)),
          $dirty: false,
        },
        longitude: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          maxLength: helpers.withMessage("تعداد کاراکتر باید 8 رقم باشد", maxLength(8)),
          minLength: helpers.withMessage("تعداد کاراکتر باید 8 رقم باشد", minLength(8)),
          $dirty: false,
        },
      },
    };
  },
};
</script>

<style>
.input-Numbers::-webkit-outer-spin-button,
.input-Numbers::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.input-Numbers[type="number"] {
  -moz-appearance: textfield;
}
</style>
